<script>
  import { Button, CodeSnippet, InlineNotification, Modal } from 'carbon-components-svelte';
  import { JsonView } from '@zerodevx/svelte-json-view';
  import Reload from 'carbon-icons-svelte/lib/WatsonHealthRotate_18020';

  import copy from 'clipboard-copy';

  import LoadingSpinner from '../../components/LoadingSpinner.svelte';
  import { convertToLocalDisplayTime } from '../../utils';

  export let open,
    state = {},
    group = {},
    debounceFetchPolicies;
</script>

<Modal passiveModal bind:open on:close>
  <div slot="heading" class="heading">Policy Details for: <strong>{group.name}</strong></div>
  <LoadingSpinner small loading={state.loading}>
    {#if state.mostRecentReconciliationData.error}
      <InlineNotification
        kind="error"
        hideCloseButton
        lowContrast
        title="Last Role Synchronization Failed"
        subtitle={state.mostRecentReconciliationData.error}
      />
    {/if}
    {#if state.error}
      <InlineNotification
        kind="error"
        hideCloseButton
        lowContrast
        title="Error Retrieving Policies"
        subtitle={state.error.message || 'Cannot retrieve policy status.'}
      />
    {/if}
    <div class="row">
      <h4 class="subheading">IAM Role name</h4>
      <CodeSnippet code={group.awsIamRoleName} copy={(text) => copy(text)} />
    </div>
    <div class="row">
      <h4 class="subheading">Policy Count</h4>
      <div>
        <strong class="count">{state.policies.length}/20</strong>
        <Button
          tooltipPosition="right"
          tooltipAlignment="end"
          iconDescription="Check again"
          icon={Reload}
          disabled={state.loading}
          on:click={debounceFetchPolicies}
          size="small"
          kind="ghost"
        />
        <div>
          <em>{convertToLocalDisplayTime(state.mostRecentReconciliationData.lastUpdatedAt)}</em>
        </div>
      </div>
    </div>
    <div class="row">
      <h4 class="subheading">Most Recent Reconciliation Logs</h4>
      <div class="logs">
        {#if state.mostRecentReconciliationData}
          <JsonView json={state.mostRecentReconciliationData} />
        {:else}
          <span>No recent reconciliation data available.</span>
        {/if}
      </div>
    </div>
  </LoadingSpinner>
</Modal>

<style>
  .row {
    margin-bottom: 1rem;
  }

  .count {
    font-family: 'Trebuchet MS', sans-serif !important;
    font-size: 1.5rem;
  }

  .heading {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 1rem;
  }

  .subheading {
    font-size: 1rem;
  }

  .logs {
    padding: 0.5rem 1rem;
    border: 1px solid var(--cds-border-strong);
    max-height: 250px;
    overflow-y: auto;
    margin-top: 0.5rem;
  }
</style>
